<template>
  <a-row :gutter="8" :class="getScreen ? 'm-list-wrapper' : 'd-list-wrapper'">
    <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
      <a-card>
        <div slot="title"><a-icon type="file-search" />&nbsp;Search</div>
        <ul class="m-list-wrapper">
          <li>
            <a-input-search v-model="search" placeholder="Quick Search" />
          </li>
          <li>
            <a-collapse :activeKey="getScreen ? 0 : 1">
              <a-collapse-panel key="1">
                <span slot="header">Search More...</span>
                <div class="m-form-item-wrapper">
                  <label>Transaction Date</label>
                  <a-range-picker
                    :placeholder="['Start Date', 'End Date']"
                    v-model="transactionDt"
                    :format="dateFormat"
                  />
                </div>
                <div class="m-form-item-wrapper">
                  <label>Category</label>
                  <a-select
                    placeholder="Ex: Value's < 100 Million Rupiah"
                    v-model="kategori"
                    class="width-full"
                    initialValue="null"
                    allowClear
                  >
                    <a-select-option value="less">Value's &#60; 100 Million Rupiah</a-select-option>
                    <a-select-option value="over">Value's &#62;= 100 Million Rupiah</a-select-option>
                  </a-select>
                </div>

                <div class="m-form-item-wrapper">
                  <label>Supplier</label>
                  <a-select
                    showSearch
                    v-model="supplier_nm"
                    placeholder="Select Supplier Name"
                    class="width-full"
                    initialValue="delivered"
                    allowClear
                  >
                    <a-select-option
                      v-for="item in wo_supplier"
                      :key="item"
                      :value="item"
                      >{{ item }}</a-select-option
                    >
                  </a-select>
                </div>

                <div class="m-form-item-wrapper">
                  <label>Transaction Status</label>
                  <a-select
                    placeholder="Ex: Approved ... "
                    v-model="status"
                    class="width-full"
                    initialValue="delivered"
                    allowClear
                  >
                    <a-select-option value="delivered"
                      >Delivered</a-select-option
                    >
                    <a-select-option value="approved">Approved</a-select-option>
                    <a-select-option value="on process"
                      >On Process</a-select-option
                    >
                    <a-select-option value="revised">Revised</a-select-option>
                    <a-select-option value="rejected">Rejected</a-select-option>
                    <a-select-option value="transferred"
                      >Transferred</a-select-option
                    >
                  </a-select>
                </div>

                <div class="m-form-item-wrapper">
                  <label>Payment Status</label>
                  <a-select
                    placeholder="Ex: Transferred ... "
                    v-model="statusPembayaran"
                    class="width-full"
                    initialValue="null"
                    allowClear
                  >
                    <a-select-option value="transferred">Transferred</a-select-option>
                    <a-select-option value="yet transferred">Not Transferred</a-select-option>
                  </a-select>
                </div>

                <div class="m-form-item-wrapper">
                  <label>Delivery Status</label>
                  <a-select
                    placeholder="Ex: Received ... "
                    v-model="statusPengiriman"
                    class="width-full"
                    initialValue="null"
                    allowClear
                  >
                    <a-select-option value="yet">Not Delivery</a-select-option>
                    <a-select-option value="process">On Process</a-select-option>
                    <a-select-option value="done">Received</a-select-option>
                    <a-select-option value="refunded">Refunded</a-select-option>
                  </a-select>
                </div>
              </a-collapse-panel>
            </a-collapse>
          </li>
        </ul>
      </a-card>
    </a-col>
    <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
      <!-- <DataList
        :loading="loading"
        title="PO List"
        createLink="createPo"
        manifestLink="PoManifest"
        editLink="editPo"
        :dataList="poSearch"
        :isTransactional="true"
        :allowcancel="true"
      /> -->
      <a-spin
        tip="Your document is being processed, do not leave this page!"
        :spinning="loadings.tab"
      >
        <DataList
            :loading="loading"
            title="PO List"
            createLink="createPo"
            manifestLink="PoManifest"
            editLink="editPo"
            :tabbedTransactional="true"
            :dataList="poSearch"
            dataListTitle="PO Transaction"
            :draftList="poDraftSearch"
            draftListTitle="Draft"
            draftEditLink="draftPo"
            :flagdisabledEdit="false"
            :draftDeleteLink="true"
            :otherList="poSearch"
            otherListTitle="PO Refund payment"
            :allowcancel="true"
          />
        </a-spin>
    </a-col>
  </a-row>
</template>


<script>
import axios from "axios";
import { mapGetters } from "vuex";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import moment from "moment";
import _ from "lodash";
import GlobalMethod from "@/mixins/GlobalMethod.js";

export default {
  name: "ListPO",
  mixins: [CurrencyFormat, GlobalMethod],
  data() {
    return {
      loading: true,
      dateFormat: "DD-MM-YYYY",
      poList: [],
      poDraftList: [],
      basedList: [],
      search: undefined,
      tempList: "",
      kategori: undefined,
      status: undefined,
      transactionDt: [],
      form: this.$form.createForm(this),
      pagination: {
        onChange: () => {},
        pageSize: 5,
        size: "small",
      },
      wo_supplier: [],
      supplier_nm: undefined,
      statusPembayaran: undefined,
      statusPengiriman: undefined,
      activeTab: "list",
      loadings: {
        tab: false,
      },
    };
  },
  created() {
    this.fetchData();
  },
  mounted() {
    Event.$on("emitDeleteLink", this.deleteDraft);
    Event.$on("handleCancel", this.canceltrans);
    Event.$on("callbackTab", this.clickTabed);
  },
  beforeDestroy() {
    Event.$off("emitDeleteLink", this.deleteDraft);
    Event.$off("handleCancel", this.canceltrans);
    Event.$off("callbackTab", this.clickTabed);
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getStandartFormatDate",
    ]),
    poSearch: function () {
      var self = this;
      let outputData = this.poList;

      if (this.search) {
        outputData = _.filter(
          outputData,
          (obj) =>
            obj.searchQ &&
            obj.searchQ.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
        );
      }

      if (this.kategori) {
        outputData = outputData.filter((item) => {
          return this.kategori=="less" ? item.estimated_valueRP<100000000 : item.estimated_valueRP>=100000000;
        });
      }

      if (this.status) {
        outputData = _.filter(
          outputData,
          (obj) =>
            obj.status &&
            obj.status.toLowerCase().indexOf(this.status.toLowerCase()) >= 0
        );
      }

      if (self.transactionDt.length > 0) {
        let startDt = moment(self.transactionDt[0]).format(
          this.getStandartFormatDate
        );
        let endDt = moment(self.transactionDt[1]).format(
          this.getStandartFormatDate
        );
        outputData = _.filter(
          outputData,
          (obj) => obj.tgl_buat >= startDt && obj.tgl_buat <= endDt
        );
      }

      if (this.supplier_nm) {
        outputData = _.filter(
          outputData,
          (obj) =>
            obj.supplier &&
            obj.supplier
              .toLowerCase()
              .indexOf(this.supplier_nm.toLowerCase()) >= 0
        );
      }

      if(this.statusPembayaran){
        outputData = _.filter(
          outputData,
          (obj) =>
            obj.statusPembayaran &&
            obj.statusPembayaran
              .toLowerCase()==this.statusPembayaran.toLowerCase()
        );
      }

      if(this.statusPengiriman){
        outputData = _.filter(
          outputData,
          (obj) =>
            obj.delivered_po_wo &&
            obj.delivered_po_wo
              .toLowerCase()==this.statusPengiriman.toLowerCase()
        );
      }

      return outputData;
    },
    poDraftSearch: function () {
      var self = this;
      let outputData = this.poDraftList;

      if (this.search) {
        outputData = _.filter(
          outputData,
          (obj) =>
            obj.searchQ &&
            obj.searchQ.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
        );
      }

      if (this.kategori) {
        outputData = outputData.filter((item) => {
          return this.kategori=="less" ? item.estimated_valueRP<100000000 : item.estimated_valueRP>=100000000;
        });
      }

      if (this.status) {
        outputData = _.filter(
          outputData,
          (obj) =>
            obj.status &&
            obj.status.toLowerCase().indexOf(this.status.toLowerCase()) >= 0
        );
      }

      if (self.transactionDt.length > 0) {
        let startDt = moment(self.transactionDt[0]).format(
          this.getStandartFormatDate
        );
        let endDt = moment(self.transactionDt[1]).format(
          this.getStandartFormatDate
        );
        outputData = _.filter(
          outputData,
          (obj) => obj.tgl_buat >= startDt && obj.tgl_buat <= endDt
        );
      }

      if (this.supplier_nm) {
        outputData = _.filter(
          outputData,
          (obj) =>
            obj.supplier &&
            obj.supplier
              .toLowerCase()
              .indexOf(this.supplier_nm.toLowerCase()) >= 0
        );
      }

      if(this.statusPembayaran){
        outputData = _.filter(
          outputData,
          (obj) =>
            obj.statusPembayaran &&
            obj.statusPembayaran
              .toLowerCase()==this.statusPembayaran.toLowerCase()
        );
      }

      if(this.statusPengiriman){
        outputData = _.filter(
          outputData,
          (obj) =>
            obj.delivered_po_wo &&
            obj.delivered_po_wo
              .toLowerCase()==this.statusPengiriman.toLowerCase()
        );
      }

      return outputData;
    },
  },
  methods: {
    moment,
    fetchData() {
      axios({
        method: "get",
        url: this.$serviceUrl + (this.activeTab == 'list' || this.activeTab == 'draft' ? "po" : "po/po_refund"),
        params: {
          tlc: this.getAuth.username,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.poList = [];
          //PO or PO Refund
          _.forEach(response.data.data, (data) => {
            this.poList.push({
              title: data.no_po,
              timeline: JSON.parse(data.status_app),
              unread: (data.unread && data.unread == "1") ? true : false,
              subdesc: [
                data.no_pp,
                // { deskripsi: data.deskripsi },
                data.deskripsi,
                data.supplier,
                this.formatCurrency(data.mata_uang, data.estimated_value),
              ],
              status: data.status,
              id: data.id_po,
              kode_project: data.kode_project,
              cancelStatus: data.cancel_sts
                ? data.cancel_sts == 1
                  ? "Canceled"
                  : (data.cancel_sts == 2 ? "Unusual":null)
                : null,
              islistPPrevised: data.cancel_sts == 2 ? true:false,
              receiveStatus: data.delivered,
              supplier: data.supplier,
              tgl_buat: data.tgl_buat,
              peruntukan: data.peruntukan,
              searchQ:
                data.no_po +
                " " +
                data.no_pp +
                " " +
                data.estimated_value +
                " " +
                data.mata_uang +
                " " +
                data.deskripsi,
              estimated_valueRP: data.estimated_valuerp,
              delivered_po_wo: data.delivered,
              closed_po_wo: data.close_sts,
              statusPembayaran: data.transfer_sts.toLowerCase()=='transferred' ? "transferred" : "yet transferred",
            });
          });

          this.poList.forEach((element) => {
            if (this.wo_supplier.indexOf(element.supplier) === -1) {
              this.wo_supplier.push(element.supplier);
            }
          });

          
          //Draft
          if(this.activeTab == 'list' || this.activeTab == 'draft') this.poDraftList = [];
          _.forEach(response.data.draft, (data) => {
            this.poDraftList.push({
              title: 'Draft',
              subdesc: [
                data.no_pp,
                data.deskripsi,
                data.nama_suplier,
                this.formatCurrency(data.currency, data.value_po),
              ],
              // status: data.status,
              id: data.id_po,
              supplier: data.supplier,
              tgl_buat: data.tgl_buat,
              peruntukan: data.peruntukan,
              loading_delete: false,
              searchQ:
                data.no_pp +
                " " +
                data.value_po +
                " " +
                data.currency +
                " " +
                data.deskripsi
            });
          });

          this.loading = false;
          this.loadings.tab = false;
        })
        .catch((err) => {
          if (!err.response) {
            this.displayMessage("error-connection-refused");
          } else {
            this.loading = false;
            this.loadings.tab = false;
            this.displayMessage("empty-db");
          }
        });
    },
    canceltrans(item) {
      axios({
        method: "post",
        url: this.$serviceUrl + "main/cancel_transaction",
        params: {
          tlc: this.getAuth.username,
        },
        data: {
          tlc: this.getAuth.username,
          jenis_trans: "po",
          id_manifest: item.id,
          code_trans: item.title,
          kode_project: item.kode_project,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.displayMessageValue("successCancel", response.data.message);
          //this.fetchData();
          this.$router.go()
          this.searching;
        })
        .catch((err) => {
          if (!err.response) {
            this.displayMessage("error-connection-refused");
          } else {
            this.loading = false;
            this.displayMessage("empty-db");
          }
        });
    },
    resetFilter() {
      this.search = null;
      this.kategori = null;
      this.status = null;
      this.supplier_nm = null;
      this.statusPembayaran = null;
      this.statusPengiriman = null;
      this.transactionDt = [];
    },
    clickTabed(val) {
      this.activeTab = val;
      this.loadings.tab = true;
      this.poList = [];
      this.fetchData();
      this.resetFilter();
    },
    deleteDraft(val) {
      console.log(val)
      const that = this;
      this.$confirm({
        title: "Are you sure to delete this data?",
        content: "",
        okText: "Yes",
        cancelText: "No",
        onOk() {
          let indx = _.findIndex(that.poDraftList, (e) => { return e.id == val.id })
          that.poDraftList[indx].loading_delete = true;
          that.asyncAxiosDelete(
            "po/draft",
            "application/json",
            that.getAuth,
            {
              id_po: val.id,
            }
          )
            .then(() => {
              that.poDraftList = _.filter(that.poDraftList, (e) => e.id != val.id)
              that.$router.go();
            })
            .catch((err) => {
              console.log(err)
              that.poDraftList[indx].loading_delete = false;
            });
        },
        onCancel() { },
      })
    }
  },
};
</script>